import React from 'react';

export default function QuoteList({ quotes, onSelectQuote }) {
    return (
        <div className="quote-list">
            {quotes.length === 0 ? (
                <p>No pending quotes</p>
            ) : (
                quotes.map((quote) => (
                    <div
                        key={quote.id}
                        className="quote-card"
                        onClick={() => onSelectQuote(quote)}
                    >
                        <div className="quote-header">
                            <h3>{quote.customerName}</h3>
                            <span className={`status-badge ${quote.status}`}>
                                {quote.status}
                            </span>
                        </div>
                        <div className="quote-info">
                            <p>Submitted by: {quote.createdBy}</p>
                            <p>Created: {new Date(quote.createdAt).toLocaleDateString()}</p>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
